(function () {
  const bar = document.getElementById('ms-category-bar');
  if (!bar) return;

  const header = document.querySelector('header');

  function setHeaderHeight() {
    const h = header ? header.getBoundingClientRect().height : 60;
    document.documentElement.style.setProperty('--header-height', h + 'px');
  }

  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight, { passive: true });

  // Non-homepage pages: always visible, nothing more to do
  if (!bar.classList.contains('ms-category-bar--homepage')) return;

  const hero = document.querySelector(
    '.hero, [data-section-type="image-banner"], .slideshow, section:first-of-type'
  );

  function onScroll() {
    const heroHeight = hero ? hero.offsetHeight : window.innerHeight;
    const headerHeight = header ? header.offsetHeight : 60;

    if (window.scrollY >= heroHeight - headerHeight) {
      bar.classList.remove('ms-category-bar--hidden');
    } else {
      bar.classList.add('ms-category-bar--hidden');
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
